// Otto Repricer Service API calls
import axios from "axios";

const OMNI_API_URL = import.meta.env.VITE_OMNI_API_URL || "/api/v1/omni";

// Create axios instance for Otto service
const OmniApiClient = axios.create({
  baseURL: OMNI_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
OmniApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default OmniApiClient;
